import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { CheckboxInput, DropdownInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const VacancyLossBasic = (props: {rowData: [], field: string, namedItems: {propertyId: number}, persist: Function}) => {

  const emptyRecord = {
    percent: null,
    reducePercentByVacancy: false,
    revenuetype: null
  }

  const [data, setData] = useState<object|null>(_.get(props, `rowData.${props.field}.state`) === 'basic' ? _.get(props, `rowData.${props.field}`) : emptyRecord);

  useEffect(() => {
    _.get(props, `rowData.${props.field}.state`) !== 'basic' ? setData(emptyRecord) : setData(_.get(props, `rowData.${props.field}`))
  }, [props['rowData']])

  useEffect(() => {
    setData(props.rowData[props.field])
  }, [props.namedItems.propertyId])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    setData(nextData);
    props.persist({percent: nextData['percent'], reducePercentByVacancy: nextData['reducePercentByVacancy'], revenuetype: nextData['revenuetype'], state: 'basic'}, 'vacancylossdetail', props.rowData[props.field])
  }

  const attrs = (field) => field_attrs('property', 'vacancylossdetail')(field)(props.rowData, props)

  const revenueTypes = [
    'Potential Base Rent',
    'Scheduled Base Rent',
    'Potential Base Rent + Recovery',
    'Potential Base Rent + Scheduled Recovery',
    'Scheduled Base Rent + Recovery',
    'Potential Tenant Revenue',
    'Potential Tenant Revenue w/Scheduled Recovery',
    'Tenant Revenue',
    'Potential Property Revenue',
    'Potential Property Revenue w/Scheduled Recovery',
    'Property Revenue'
  ]

  let formData = data && data['state'] === 'basic' ? data : emptyRecord

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>Percent</label>
          <NumberInput className="automated" data={formData} attrs={attrs} field="percent" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
        <div className="revenue-type-dropdown">
          <label>Revenue Type</label>
          <DropdownInput className="automated" data={formData} attrs={attrs} field="revenuetype" default={_.get(formData, "revenuetype")} options={revenueTypes} persist={updateData} />
        </div>
        <div>
          <label>Reduce % by Vacancy</label>
          <CheckboxInput className="automated" data={formData} field="reducePercentByVacancy" persist={updateData} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default VacancyLossBasic